import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  getMessages(): Observable<any> {
    return this.http.get(`${this.configs.get().apiUrl}/messages`);
  }
  saveMessage(message: string): Observable<any> {
    var data = {
      message: message
    };
    return this.http.post(`${this.configs.get().apiUrl}/admin/messages`, data);
  }
}
